import { CrmAuthConfig } from 'common-module/auth';

import { LoginFormProvider } from './providers/login-form.provider';

export const authConfig: CrmAuthConfig = {
  components: {
    wrapper: {
      logoSrc: 'assets/icons/logo_colored.png'
    },
    login: {
      showForgottenPassword: false,
      providers: {
        form: LoginFormProvider
      }
    }
  }
};
